export const KatexStyles = () => (
  <link rel='stylesheet' type='text/css' href='https://cdn.jsdelivr.net/npm/katex@0.15.0/dist/katex.min.css' />
);
